export const UI_MESSAGE_TRANSLATIONS_KEY: string = '$ui_message_translations';
